import { render, staticRenderFns } from "./FeriadoModal.vue?vue&type=template&id=34a5ce7e&scoped=true"
import script from "./FeriadoModal.vue?vue&type=script&lang=js"
export * from "./FeriadoModal.vue?vue&type=script&lang=js"
import style0 from "./FeriadoModal.vue?vue&type=style&index=0&id=34a5ce7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a5ce7e",
  null
  
)

export default component.exports